module.exports = __webpack_public_path__ + "img/reference44.1e9973ef.jpg";